import FormDrawer from '../form-drawer';
import SlideToggle from "components/__new/common/form/SlideToggle";
import greenbar from "assets/images/icons/green-rectangle-bar.svg";
import React, { useState } from 'react';



const EditRolePermissionsModal = (props) => {
const {isOpen, setIsOpen} = props;
const [toggleActive, setToggleActive] = useState(false);
const handleToggle = () => {
    setToggleActive(!toggleActive);
}



    return (
    
        <FormDrawer display="center" size="2xl" isOpen={isOpen} setIsOpen={setIsOpen}>
            <div className="p-6">
                <FormDrawer.Title
                    title="Edit Role"
                    showCloseButton={true}
                    close={setIsOpen}
                />
                
                {/* <CreateCustomRoleModal 
                    isOpen={showCreateCustomRoleModal}
                    setIsOpen={setShowCreateCustomRoleModal}
                /> */}
                
                <div>
                    <div>
                        <div className='flex my-2 font-medium text-ep-gray-600'>
                            <div className='pr-3'>
                                <img src={greenbar} alt="" />
                                <div className='py-2'>Role Details</div>
                            </div>
                            <div>
                                <img src={greenbar} alt="" />
                                <div className='py-2'>Permissions</div>
                            </div>
                        </div>
                    </div>
                    
                    <section>
                    <div className='flex mt-3'>
                        <div>
                            <SlideToggle 
                            onChange={handleToggle}
                            active={toggleActive}
                            />
                        </div>
                        <div className='text-ep-gray-600 pl-3'>Assign all permissions for this role</div>
                    </div>
                    <main className=''>
                <section className=''>
                    {/* {rolePermission?.data?.map((role) => (
                        <div key={role.id} className="role-section">
                            <div className="flex my-6 bg-ep-gray-100 py-6 pl-6 rounded-lg">
                        <h3 className='text-black font-bold'>{role.name}{' - '}</h3>
                        <p className=' text-ep-gray-600 font-medium'>{' '}{role.description}</p>
                        </div>
                        {role?.companiesPermissions?.map((permission) => (
                            <div key={permission.id} className="permission-item">
                            <label className='inline-block mb-4'> 
                                <input
                                type="checkbox"
                                checked={selectedPermissions.includes(permission.id)}
                                onChange={() => handleCheckboxChange(permission.id)}
                                className='form-checkbox w-5 h-5 multi-select-header mr-3'
                                />
                                <span className="font-normal text-ep-gray-300">
                                    {permission.description}
                                </span>
                            </label>
                            </div>
                        ))}
                        </div>
                    ))} */}
                </section>
                <div className='flex justify-end'>
                    <button type="button" onClick={() => setIsOpen(false)} className="btn btn-lg w-24 rounded-lg whitespace-nowrap border border-ep-primary-600 text-white bg-ep-primary-600">
                        Close
                    </button>
                </div>
            </main>
                    </section>
                    
                    <div className="p-1 mt-4 flex justify-end space-x-3">
                        <div className='flex'>
                            <div className='pr-5'>
                                <button onClick={setIsOpen} type="button" className="btn btn-lg w-full rounded-lg whitespace-nowrap border border-ep-primary-600 text-ep-primary-600 bg-white"                    >
                                    Back
                                </button>
                            </div>
                            <div>
                                <button type="button" className="btn btn-lg w-full rounded-lg whitespace-nowrap border border-ep-primary-600 text-white bg-ep-primary-600">
                                    Save Changes
                                </button>
                            </div>
                        </div>
                    </div>    
                </div>
            </div>
    </FormDrawer>
  )
}

export default EditRolePermissionsModal
